/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import TableVault from './components/TableVault'
import { FormControl, FormLabel, Select, Button } from '@chakra-ui/react'

const OrganizationVault = ({ vaults }) => {
  const defaultVault = vaults?.find(vault => vault.isDefault)
  const [vaultSelected, setVaultSelected] = useState(defaultVault)

  const { register, handleSubmit, watch, formState: { isDirty } } = useForm({
    defaultValues: {
      vaultId: defaultVault?.id || ''
    }
  })

  const watchedVaultId = watch('vaultId')

  useEffect(() => {
    if (watchedVaultId) {
      const selected = vaults.find(vault => +vault.id === +watchedVaultId)
      setVaultSelected(selected)
    }
  }, [watchedVaultId, vaults])

  const onSubmit = (data) => {
    console.log('Form submitted with vault ID:', data.vaultId)
  }

  return (
    <>
      <h3>Organization Vault</h3>
      { vaults &&
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormControl
            mb={4}
          >
            <FormLabel>
              Select Organization Vault
            </FormLabel>
            <Select
              {...register('vaultId')}
            >
              {
                vaults.map(
                  option => (
                    <option
                      value={option.id}
                      key={option.id}
                    >
                      { option.name }
                    </option>
                  )
                )
              }
            </Select>
          </FormControl>
          <TableVault vaultBinding={vaultSelected} />
          <Button
            type="submit"
            isDisabled={!isDirty}
          >
            Save vault
          </Button>
        </form>
      }
    </>
  )
}

export default OrganizationVault
